import { uniqBy, toLower, trim } from 'lodash-es';
import i18next from '@/lib/i18next';

export const BLANK_OPTION_EXCEPTION_TEXT = 'Empty Fields - You have Responses that are empty.';
export const MINIMUM_OPTIONS_EXCEPTION_TEXT = 'Must have at least 2 Responses.';
export const CORRECT_ID_EXCEPTION_TEXT = 'Correct Response Missing - You need to select one or more of your responses to be the correct answer.';
export const DUPLICATE_OPTIONS_EXCEPTION_TEXT = 'Unique Answers - You have Responses that are duplicates.';
export const BLANK_PROMPT_EXCEPTION_TEXT = 'Empty Fields - The Question Prompt is empty.';
export const LONG_PROMPT_EXCEPTION_TEXT = 'The Question Prompt has too many characters';

export const LONG_PROMPT_CHAR_LIMIT = 450;
/**
 * Check the validity of an interactive module before saving to Pinia/sending a PATCH
 * @param moduleData - Full module data from the store
 * @returns {Boolean} - `true` if TEI is valid
 * @throws {Error} If TEI is invalid, with reason as the error message
 */
export function validateTEI(moduleData) {
  const { options } = moduleData.options;
  const isMultipleChoice = options
    && ['single_selection', 'multiple_selection'].indexOf(moduleData.type) !== -1;

  if (isMultipleChoice) {
    if (options.some((opt) => !trim(opt))) {
      throw new Error(i18next.t(BLANK_OPTION_EXCEPTION_TEXT));
    }

    if (options.length < 2) {
      throw new Error(i18next.t(MINIMUM_OPTIONS_EXCEPTION_TEXT));
    }

    if (!moduleData.options.valid_options.length) {
      throw new Error(i18next.t(CORRECT_ID_EXCEPTION_TEXT));
    }

    const duplicateFormatter = (opt) => trim(toLower(opt));
    if (uniqBy(options, duplicateFormatter).length !== options.length) {
      throw new Error(i18next.t(DUPLICATE_OPTIONS_EXCEPTION_TEXT));
    }
  }

  if (!trim(moduleData.options.content)) {
    throw new Error(i18next.t(BLANK_PROMPT_EXCEPTION_TEXT));
  }

  if (moduleData.options.content.length > LONG_PROMPT_CHAR_LIMIT) {
    throw new Error(i18next.t(LONG_PROMPT_EXCEPTION_TEXT));
  }

  return true;
}
